import React, { useState, useMemo, useRef, useEffect } from "react";
import {
  clocksmall,
  proceesingblue,
  checkout,
  cancelled,
  noshow,
  readyforcheckout,
} from "../svgs";
import DateRangeSelector from "../../../daterangepicker/DateRangeSelector";
import dayjs from "dayjs";
import OrderHistoryModal from "../orderhistorymodal";
import api from "../../../api/api";
import { set } from "date-fns";
import { Backdrop, CircularProgress } from "@mui/material";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

// Status Classes
const getStatusClasses = (status) => {
  switch (status) {
    case "Checked Out":
      return "bg-[#F1F5F9] text-[#007A55] border-[1px] border-[#A4F4CF]";
    case "Processing":
      return "bg-[#F0FDF4] text-[#1447E6] border-[1px] border-[#BEDBFF]";
    case "Cancelled":
      return "bg-[#F0FDF4] text-[#C10007] border-[1px] border-[#FFC9C9]";
    case "No Show":
      return "bg-[#FAF5FF] text-[#364153] border-[1px] border-[#E5E7EB]";
    case "Ready for Checkout":
      return "bg-[#F1F5F9] text-[#BB4D00] border-[1px] border-[#FEE685]";
    default:
      return "bg-gray-50 text-gray-600 border-[1px] border-gray-200";
  }
};

// Status Icons
const getStatusIcon = (status) => {
  switch (status) {
    case "Checked Out":
      return checkout;
    case "Processing":
      return proceesingblue;
    case "Cancelled":
      return cancelled;
    case "No Show":
      return noshow;
    case "Ready for Checkout":
      return readyforcheckout;
    default:
      return null;
  }
};

// Format Date
const formatDateTime = (datetimeStr) => {
  if (!datetimeStr) return "—";
  const date = new Date(datetimeStr);
  if (isNaN(date.getTime())) return "—";

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

// Format Time
const formatTime = (datetimeStr) => {
  if (!datetimeStr) return "—";
  const date = new Date(datetimeStr);
  if (isNaN(date.getTime())) return "—";

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "pm" : "am";
  hours = hours % 12 || 12;

  return `${hours}:${minutes} ${ampm}`;
};

const AppointmentHistory = ({ appointmenthistory = [],activeTab,data,isLoading = false }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 5;
   const [orderhistory,setOrdersHistory]=useState(false)
   const practiseid = window.getPracticeId();
   const[Loading,setIsLoading]=useState(false)
   const [orderdetails,setOrderDetails]=useState({})
   const [apphistory,setAppHistory]=useState('')
   const [selectedAppointment,setSelectedAppointment]=useState(null)
  // Date range state
  const [selectedDateRange, setSelectedDateRange] = useState({
    startDate: null,
    endDate: null,
    key: "selection",
  });

  // Modal state
  const [showCalendar, setShowCalendar] = useState(false);
  const calendarRef = useRef(null);

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (calendarRef.current && !calendarRef.current.contains(e.target)) {
        setShowCalendar(false);
      }
    };
    if (showCalendar) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showCalendar]);

  // Handlers for DateRangeSelector
  const handleDateApply = () => {
    setCurrentPage(1); // reset to first page when filtering
    setShowCalendar(false);
  };

  const handleDateReset = () => {
    setSelectedDateRange({
      startDate: null,
      endDate: null,
      key: "selection",
    });
    setCurrentPage(1);
    setShowCalendar(false);
  };

  // Filtered appointments by date
  const filteredAppointments = useMemo(() => {
    if (!selectedDateRange.startDate || !selectedDateRange.endDate) {
      return appointmenthistory;
    }
    const start = new Date(selectedDateRange.startDate).setHours(0, 0, 0, 0);
    const end = new Date(selectedDateRange.endDate).setHours(23, 59, 59, 999);

    return appointmenthistory.filter((a) => {
      const apptDate = new Date(a.startdate).getTime();
      return apptDate >= start && apptDate <= end;
    });
  }, [appointmenthistory, selectedDateRange]);

  // Pagination logic
  const totalPages = Math.ceil(filteredAppointments.length / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const currentAppointments = filteredAppointments.slice(
    startIndex,
    startIndex + rowsPerPage
  );
const fetchordersdata=async({id,st,load})=>{
if(load){
    setIsLoading(true)
}
  try {
    const response=await api.post(`/v1/${practiseid}/orders/patient/${data?.patientid}/get-orders`,{
      "appointmentid":id,"orderdate":dayjs(st).format("YYYY-MM-DD")
    })

const isoDate = dayjs(st).format("YYYY-MM-DDTHH:mm:ss.SSS");

    const apphis=await api.post(`/v1/${practiseid}/pcard/${data?.patientid}/appHistory`,{
     "appointment_id":id,  apptdate:isoDate})
    if(response.status==200){
      setOrderDetails(response.data)
 
    }
    if(apphis.status==200){
      setAppHistory(apphis)
    }
  } catch (error) {
    console.log(error)
  }finally{
setIsLoading(false)
     setOrdersHistory(true)
  }
}
  return (
    <div className="bg-white rounded-lg min-h-[70vh] shadow p-4">
      {/* Header */}
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-inter font-semibold text-[#101828]">
          Appointment History
        </h2>

        <div className="flex items-center gap-2">
          {/* Date Range Toggle Button */}
          <div className="relative" ref={calendarRef}>
            <button
              onClick={() => setShowCalendar((prev) => !prev)}
              className="px-4 py-2 border rounded-lg text-sm font-medium bg-white text-[#3A3A49] hover:bg-gray-50 shadow-sm"
            >
              {selectedDateRange.startDate && selectedDateRange.endDate
                ? `${dayjs(selectedDateRange.startDate).format("MM/DD/YYYY")} - ${dayjs(
                    selectedDateRange.endDate
                  ).format("MM/DD/YYYY")}`
                : "Select Date Range"}
            </button>

            {/* Calendar Modal */}
            {showCalendar && (
              <div className="absolute right-0 mt-2 z-50 bg-white shadow-lg rounded">
                <DateRangeSelector
                  onSubmit={handleDateApply}
                  handlereset={handleDateReset}
                  selectedDateRange={selectedDateRange}
                  setSelectedDateRange={setSelectedDateRange}
                />
              </div>
            )}
          </div>
           {selectedDateRange.startDate && selectedDateRange.endDate && (
    <div className="flex items-center gap-1 px-3 py-1 rounded-full text-xs bg-blue-50 text-blue-700 border border-blue-200">
      {dayjs(selectedDateRange.startDate).format("MM/DD/YYYY")} -{" "}
      {dayjs(selectedDateRange.endDate).format("MM/DD/YYYY")}
      <button
        onClick={handleDateReset}
        className="ml-1 text-blue-500 hover:text-blue-700"
      >
        ✕
      </button>
    </div>
  )}

          <span className="px-3 py-1 rounded-[10px] text-[11px] font-inter font-medium bg-[#50869A1A] border-[1px] border-[#50869A33] text-gray-600">
            {filteredAppointments.length} Total Appointments
          </span>
        </div>
      </div>

      {/* Table */}
      <div className="overflow-hidden rounded-xl border border-gray-200">
        {isLoading ? (
          <div className="p-4 text-center text-gray-500">Loading...</div>
        ) : filteredAppointments.length === 0 ? (
          <div className="p-4 text-center text-gray-500">
            No appointments found
          </div>
        ) : (
          <>
            <table className="w-full text-sm text-center min-h-[60vh]">
              <thead className="bg-[#4a7c8f] text-[#FFFFFF] font-inter text-[13px]">
                <tr>
                  <th className="px-4 py-4 font-medium">Date & Time</th>
                  <th className="px-4 py-4 font-medium">Purpose</th>
                  <th className="px-4 py-4 font-medium">Visit Status</th>
                  <th className="px-4 py-4 font-medium">Actions</th>
                </tr>
              </thead>
<tbody className="divide-y divide-gray-100">
  {currentAppointments.map((a, idx) => (
    <tr key={idx} className="hover:bg-gray-50 align-top">
      {/* Date & Time */}
      <td className="px-4 py-3 align-top">
        <div className="flex flex-col justify-start">
        <div className="font-semibold text-[13px] font-inter text-[#101828]">
          {a.start_date ? formatDateTime(a.start_date) : "—"}
        </div>
        <div className="flex items-center justify-center gap-1 text-xs font-inter font-medium text-[#4A5565]">
          {clocksmall}
          <span>
            {a.start_date ? formatTime(a.start_date) : "—"}
          </span>
        </div>
        </div>
      </td>

      {/* Purpose */}
      <td className="px-4 py-3 align-top">
        <span className="px-2.5 py-1 text-[11px] font-medium font-inter rounded-full border border-[#50869A33] bg-[#50869A1A] text-[#6A7282]">
          {a.purpose}
        </span>
      </td>

      {/* Status */}
      <td className="px-4 py-3 align-top">
        {a.visit_confirmation ? (
          <span
            className={`inline-flex items-center font-inter font-medium gap-1 px-2.5 py-1 text-xs rounded-[10px] ${getStatusClasses(
              a.visit_confirmation
            )}`}
          >
            {getStatusIcon(a.visit_confirmation)}
            {a.visit_confirmation}
          </span>
        ) : (
          ""
        )}
      </td>

      {/* Actions */}
      <td className="px-4 py-3 align-top">
        <button
     onClick={() =>{
      setSelectedAppointment(a)
  fetchordersdata({
    id: a.appointmentid,
    st: a.startdate,load:true // only date
  })}
}
        className="px-3 py-1 text-xs rounded-[10px] border bg-[#FFFFFF] border-[#50869A4D] font-inter font-medium text-[#6A7282] hover:bg-gray-100">
          Order history
        </button>
      </td>
    </tr>
  ))}
</tbody>

            </table>

            {/* Pagination */}
            <div className="flex justify-between items-center p-3 border-t border-gray-200 text-sm">
              <span className="text-gray-600">
                Page {currentPage} of {totalPages}
              </span>
              <div className="flex gap-2">
                <button
                  className="px-3 py-1 rounded-md border text-gray-700 disabled:opacity-50"
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage((p) => p - 1)}
                >
                  Prev
                </button>
                <button
                  className="px-3 py-1 rounded-md border text-gray-700 disabled:opacity-50"
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage((p) => p + 1)}
                >
                  Next
                </button>
              </div>
            </div>
          </>
        )}
      </div>
         <Backdrop
  sx={{
    color: '#fff',
    zIndex: (theme) => theme.zIndex.drawer + 1,
    backgroundColor: 'rgba(0, 0, 0, 0.7)', // reduced opacity (default is 0.5)
  }}
  open={Loading}
>
  <CircularProgress color="inherit" />
</Backdrop>
            {orderhistory?<OrderHistoryModal
            selectedAppointment={selectedAppointment}
            apphis={apphistory}
            data={data}
            orderdetails={orderdetails}
            isOpen={orderhistory} onClose={setOrdersHistory}/>:<></>}
    </div>
  );
};

export default AppointmentHistory;
